<template>
  <td><slot /></td>
</template>
